var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusInReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41465 6.58674C10.1953 7.36741 10.1953 8.63474 9.41465 9.41674C8.63398 10.1974 7.36665 10.1974 6.58465 9.41674C5.80398 8.63608 5.80398 7.36874 6.58465 6.58674C7.36665 5.80474 8.63331 5.80474 9.41465 6.58674",
    stroke: "#6576E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.6667L12 12.6667L10.6667 11.3334",
    stroke: "#6576E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6666C5.53933 12.6666 3.30733 11.3393 2.29733 9.27459V9.27459C2.10133 8.87392 2 8.43925 2 7.99992C2 7.56059 2.10133 7.12592 2.29733 6.72525V6.72525C3.30733 4.66059 5.53933 3.33325 8 3.33325C10.4607 3.33325 12.6927 4.66059 13.7027 6.72525V6.72525C13.8987 7.12592 14 7.56059 14 7.99992",
    stroke: "#6576E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusInReview);
export default __webpack_public_path__ + "static/media/status-in_review.b00c8d6b975598f6099ab7f217de57bc.svg";
export { ForwardRef as ReactComponent };